import { RouteRecordRaw } from "vue-router";
import DesignSystem from "@/components/pages/DesignSystem.vue";
import MainView from "@/components/templates/MainView.vue";

export const designSystemRoutes: RouteRecordRaw[] = [
  /**  -----  design system links ----- **/
  {
    path: "/ds",
    name: "Design System",
    component: MainView,
    children: [
      {
        path: "",
        name: "Design System",
        component: DesignSystem,
        children: [],
      },
    ],
  },
];
